import React, { useState, useEffect, useRef } from 'react';
import { Card, Form } from 'react-bootstrap';
import ErrorComponent from '../../../Components/ErrorMessage';
import { replacePlaceholder } from '../../../Utils/Utils';

function SelectListQuestionWithArr({ question, handleChange, formValues, showError }) {
  const [searchValue, setSearchValue] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const isMandatory = question.isMandatory;
  const questionText = replacePlaceholder(question.questionText, formValues);

  // Get current value from formValues
  const currentValue = formValues[question.tempId] || '';
  const hasAnswer = currentValue !== '';

  // Initialize searchValue with current value when component mounts
  useEffect(() => {
    if (currentValue) {
      setSearchValue(currentValue);
    }
  }, [currentValue]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    if (value.length >= 3) {
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const handleSelectChange = (value) => {
    setSearchValue(value);
    handleChange({
      target: { 
        name: question.tempId, 
        value: value, 
        type: question.type 
      },
    });
    setShowDropdown(false);
  };

  const getFilteredOptions = () => {
    if (question.choices && question.choices.length > 0) {
      let optionsArray = [];
      
      // Handle different choice formats
      if (typeof question.choices[0] === 'string') {
        optionsArray = question.choices[0].split(',');
      } 
      else if (question.choices[0]?.text) {
        optionsArray = question.choices[0].text.split(',');
      }
      else if (question.choices[0]?.value) {
        optionsArray = question.choices[0].value.split(',');
      }
      
      // Filter options based on search value if options were found
      if (optionsArray.length > 0 && searchValue) {
        return optionsArray.filter(option => 
          option.toLowerCase().includes(searchValue.toLowerCase())
        );
      }
      
      return optionsArray;
    }
    return [];
  };

  const renderOptions = () => {
    const filteredOptions = getFilteredOptions();
    return filteredOptions.map((option) => (
      <div
        key={option}
        className="dropdown-item"
        onClick={() => handleSelectChange(option)}
      >
        {option}
      </div>
    ));
  };

  const handleWindowClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShowDropdown(false);
    }
  };

  const handleEscapeKey = (e) => {
    if (e.key === 'Escape') {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleWindowClick);
    window.addEventListener('keydown', handleEscapeKey);
    return () => {
      window.removeEventListener('click', handleWindowClick);
      window.removeEventListener('keydown', handleEscapeKey);
    };
  }, []);

  return (
    <Card className={`mt-3 ${isMandatory && showError && !hasAnswer ? 'border-danger' : ''}`}>
      <Card.Body>
        <div className="d-flex flex-column">
          <Form.Label>
            <b style={{whiteSpace: 'pre-wrap',wordBreak: 'break-word'}}>
              {question.tempId}.{questionText}
              {isMandatory && <span className="text-danger">*</span>}
            </b>
          </Form.Label>
          <Form.Label>
            <b style={{ color: 'lightblue' }}>{question.questionDescription}</b>
          </Form.Label>
          {isMandatory && showError && !hasAnswer && (
            <ErrorComponent message={question.requiredErrorText} />
          )}
        </div>
        <div className="dropdown" ref={dropdownRef}>
          <input
            type="text"
            name={question.tempId}
            value={searchValue}
            onChange={handleSearchChange}
            className="form-control"
            placeholder={question.placeHolderText}
          />
          {showDropdown && (
            <div className="dropdown-menu w-100" style={{ display: 'block' }}>
              {renderOptions()}
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default SelectListQuestionWithArr;
